//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

    /**
     * Container component to hold multiple search-filter controls and communicate key/value changes to a search-filter-set. This component must
     * be nested within a search-filter-set. This component can contain search-filter controls such as search-filter-single-selector and
     * search-filter-checkbox. The search-filter receives value updates from its nested controls and sends this updates to the search-filter-set.
     * @param {string} key - key to use in key/value pair
     * @param {string} label - display label for the filter
     * @param {function} comparableExtractor - optional helper function used to compare filter values; helpful when filter values are objects
     */
  curalate.component('searchFilter', {
    bindings: {
      key: '@',
      label: '@',
      comparableExtractor: '&?',
    },
    template: require('@legacy-components/filters/search-filter.html'),
    transclude: true,
    require: {
      searchFilterSet: '^searchFilterSet',
      searchFilterLoadable: '?^searchFilterLoadable',
    },
    controller: ['rx', 'SearchFilterUpdates',
      function(rx, SearchFilterUpdates) {
        const self = this;
        let values = [];
        let lockedKey = false;
        let setValueStreamDisposable;
        const filterValueStream = new rx.Subject();
        const defaultComparableExtractor = function(filter) {
          return filter;
        };

                /**
                 * Gets an observable stream of options that are applied to the filter you've supplied
                 * Return type format is a map from filter keys to a list of values set for that key
                 */
        this.getFilterValueStream = function() {
          return filterValueStream;
        };

        const sendUpdates = function(changeSet) {
          self.searchFilterSet.updateFilter(self.key, angular.copy(values), changeSet);
          filterValueStream.next(angular.copy(values));
        };

        this.isKeyLocked = function() {
          return lockedKey;
        };

        this.$onInit = function() {
          const updateObj = {};
          updateObj[SearchFilterUpdates.INIT] = true;

          self.isLoading = !this.searchFilterLoadable && self.searchFilterSet.isSetLoadable;

          const filterState = self.searchFilterSet.getFilterState();
          if (filterState[self.key]) {
            lockedKey = self.searchFilterSet.isKeyLocked(self.key);
            values = filterState[self.key] || [];
          }
          sendUpdates(updateObj);

          setValueStreamDisposable = self.searchFilterSet.getFilterValueStream().subscribe((setUpdate) => {
            values = setUpdate.setObject[self.key] || [];
            filterValueStream.next(values);
          });

          self.searchFilterSet.loadingStateObservable.subscribe((isSetLoading) => {
            self.isLoading = isSetLoading;
          });

          if (self.comparableExtractor) {
            self.searchFilterSet.registerFilterComparator(self.key, self.comparableExtractor());
          }
        };

        this.$onDestroy = function() {
          setValueStreamDisposable.unsubscribe();
        };

        this.$onChanges = function() {
          self.searchFilterSet.registerFilterKeyAlias(self.key, self.label);
        };

                /**
                 * Removes all values current set for this filter
                 */
        this.clearValues = function() {
          const oldValues = angular.copy(values);
          values = [];

          const updateObj = {};
          updateObj[SearchFilterUpdates.REMOVE] = oldValues;

          if (!angular.equals(oldValues, values)) {
            sendUpdates(updateObj);
          }
        };

                /**
                 * Removes an individual value from this filter
                 *
                 * @param selectionToRemove     Value to be removed from the search filter
                 */
        this.removeValue = function(selectionToRemove) {
          self.removeValues([selectionToRemove]);
        };

        this.removeValues = function(selectionsToRemove) {
          const oldValues = angular.copy(values);
          const comparable = self.comparableExtractor ? self.comparableExtractor() : defaultComparableExtractor;

          const updateObj = {};
          updateObj[SearchFilterUpdates.REMOVE] = selectionsToRemove;

          values = _(values).reject(val => selectionsToRemove.some(selection => comparable(selection) === comparable(val)));

          if (!angular.equals(oldValues, values)) {
            sendUpdates(updateObj);
          }
        };

        this.addValues = function(selectionsToAdd) {
          const comparable = self.comparableExtractor ? self.comparableExtractor() : defaultComparableExtractor;
          const newValues = _(selectionsToAdd).filter((option) => {
            return !_.isUndefined(option) &&
                            !_.isNull(option) &&
                            !_(values).some(currentValue => comparable(currentValue) === comparable(option));
          });

          const updateObj = {};
          updateObj[SearchFilterUpdates.ADD] = selectionsToAdd;

          if (!_.isEmpty(newValues)) {
            values = values.concat(newValues);
            sendUpdates(updateObj);
          }
        };

        this.addValue = function(selectionToAdd) {
          self.addValues([selectionToAdd]);
        };

        this.setValue = function(newValue) {
          self.setValues([newValue]);
        };

        this.setValues = function(newValues) {
          const updateObj = {};
          updateObj[SearchFilterUpdates.SET] = newValues;

          values = newValues;
          sendUpdates(updateObj);
        };

        this.registerFilterOptionAlias = function(optionKey, alias) {
          return self.searchFilterSet.registerFilterOptionAlias(self.key, optionKey, alias);
        };

        this.getValue = function() {
          return values;
        };
      },
    ],
  });
})();
